import React, { useState } from 'react';
import HrDashboardAside from './HrDashboardAside';
// import './Announcements.css';

const Announcement = () => {
    // State to hold form data
    const [formData, setFormData] = useState({
        announcementTitle: '',
        announcementContent: '',
        announcementDate: '',
        expirationDate: '',
        targetAudience: 'all',
        announcementFile: null,
        announcementStatus: 'active',
        priority: 'medium',
        visibility: 'public',
    });

    // State to hold fetched announcements
    const [announcements, setAnnouncements] = useState([]);

    // Handle form field changes
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    // Handle file input change
    const handleFileChange = (e) => {
        setFormData({
            ...formData,
            announcementFile: e.target.files[0],
        });
    };

    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault();

        const data = new FormData();
        data.append('announcement_title', formData.announcementTitle);
        data.append('announcement_content', formData.announcementContent);
        data.append('announcement_date', formData.announcementDate);
        data.append('expiration_date', formData.expirationDate || '');
        data.append('target_audience', formData.targetAudience);
        data.append('announcement_file', formData.announcementFile); // File field
        data.append('announcement_status', formData.announcementStatus);
        data.append('priority', formData.priority);
        data.append('visibility', formData.visibility);

        try {
            const response = await fetch('https://cleezoclass.com:8443/api/create', {
                method: 'POST',
                body: data,
            });
            const result = await response.json();
            if (result.message) {
                alert(result.message);
            } else if (result.error) {
                alert(result.error);
            }
        } catch (error) {
            console.error('Error:', error);
            alert('There was an error while submitting the form.');
        }
    };

    // Fetch announcements
    const handleGetAnnouncements = async () => {
        try {
            const response = await fetch('https://cleezoclass.com:8443/api/announcements');
            const result = await response.json();
            if (result && result.announcements && result.announcements.length > 0) {
                setAnnouncements(result.announcements);
            } else {
                alert('No announcements available.');
            }
        } catch (error) {
            console.error('Error:', error);
            alert('There was an error while fetching the announcements.');
        }
    };

    return (
        <div className=" mainBlock Announcementblock">
            <HrDashboardAside />
            <div className='Ancontainer'>
                <h1>Create Announcement</h1>
                <form onSubmit={handleSubmit} encType="multipart/form-data">
                    <div className="form-group">
                        <label htmlFor="announcementTitle">Announcement Title *</label>
                        <input
                            type="text"
                            id="announcementTitle"
                            name="announcementTitle"
                            value={formData.announcementTitle}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="announcementContent">Announcement Content *</label>
                        <textarea
                            id="announcementContent"
                            name="announcementContent"
                            rows="6"
                            value={formData.announcementContent}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="targetAudience">Target Audience *</label>
                        <select
                            id="targetAudience"
                            name="targetAudience"
                            value={formData.targetAudience}
                            onChange={handleChange}
                            required
                        >
                            <option value="all">All Employees</option>
                            <option value="specific">Specific Departments</option>
                            <option value="group">Custom Group</option>
                        </select>
                    </div>
                    <div className="form-group">
                        <label htmlFor="announcementDate">Announcement Date *</label>
                        <input
                            type="date"
                            id="announcementDate"
                            name="announcementDate"
                            value={formData.announcementDate}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="expirationDate">Expiration Date (Optional)</label>
                        <input
                            type="date"
                            id="expirationDate"
                            name="expirationDate"
                            value={formData.expirationDate}
                            onChange={handleChange}
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="announcementFile">Upload Files (Optional)</label>
                        <input
                            type="file"
                            id="announcementFile"
                            name="announcement_file"
                            onChange={handleFileChange}
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="announcementStatus">Status *</label>
                        <select
                            id="announcementStatus"
                            name="announcementStatus"
                            value={formData.announcementStatus}
                            onChange={handleChange}
                            required
                        >
                            <option value="active">Active</option>
                            <option value="inactive">Inactive</option>
                            <option value="draft">Draft</option>
                        </select>
                    </div>
                    <div className="form-group">
                        <label htmlFor="priority">Priority *</label>
                        <select
                            id="priority"
                            name="priority"
                            value={formData.priority}
                            onChange={handleChange}
                            required
                        >
                            <option value="high">High</option>
                            <option value="medium">Medium</option>
                            <option value="low">Low</option>
                        </select>
                    </div>
                    <div className="form-group">
                        <label htmlFor="visibility">Visibility *</label>
                        <select
                            id="visibility"
                            name="visibility"
                            value={formData.visibility}
                            onChange={handleChange}
                            required
                        >
                            <option value="public">Public</option>
                            <option value="private">Private</option>
                        </select>
                    </div>
                    <button type="submit">Create Announcement</button>
                </form>
                <div>
                    <button onClick={handleGetAnnouncements}>Get Announcements</button>
                </div>
                {announcements.length > 0 && (
                    <table>
                        <thead>
                            <tr>
                                <th>Title</th>
                                <th>Content</th>
                                <th>Date</th>
                                <th>Expiration Date</th>
                                <th>Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {announcements.map((item, index) => (
                                <tr key={index}>
                                    <td>{item.announcement_title}</td>
                                    <td>{item.announcement_content}</td>
                                    <td>{item.announcement_date}</td>
                                    <td>{item.expiration_date || 'N/A'}</td>
                                    <td>{item.announcement_status}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
            </div>

        </div>
    );
};

export default Announcement;
